import { Scene } from 'scrollmagic'
import { BREAKPOINTS } from '/javascripts/constants/breakpoints'
import bus from '/javascripts/bus'
import UI from '/javascripts/utils/UI'
import scrollController from '/javascripts/utils/scrollController'

UI({
  component: '.js-overviewPage',
  container: '.js-overviewPage-container',
  title: '.js-overviewPage-title'
}, ({ container, title }) => {
  const state = { scene: null }

  check()
  bus.on('windowResize', check)

  if (document.readyState !== 'complete') {
    document.addEventListener('readystatechange', ({ target: { readyState } }) => {
      if (readyState === 'complete') check()
    })
  }

  function check() {
    destroy()

    const titleFitsInViewport = window.innerHeight - title.clientHeight > container.offsetTop /* check if it's useful to make the title sticky */
    if (titleFitsInViewport && window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET}px)`).matches) {
      create()
    }
  }

  function create() {
    const duration = container.clientHeight - title.clientHeight
    state.scene = new Scene({
      triggerElement: container,
      triggerHook: container.offsetTop / window.innerHeight,
      duration: duration > 0 ? duration : 0
    })
      .setPin(title, { pushFollowers: false })
      .addTo(scrollController)
  }

  function destroy() {
    state.scene && state.scene.destroy(true)
  }
})
